module.exports = __webpack_public_path__ + "static/media/Engpic6.ee91c39d.png";